// Sample borrower Contact record data, shaped like the Salesforce objects
// this page is meant to translate into (Contact + related Loan__c).

export type ChecklistStatus = "complete" | "incomplete";

export interface BorrowerContact {
  firstName: string;
  lastName: string;
  phone: string;
  mobilePhone: string; // only surfaced if it differs from primary phone
  email: string;
  birthdate: string; // ISO
  leadSource: string;
  mailingStreet: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  hasCoBorrower: boolean;
  coBorrowerName?: string;
}

export interface LatestLoan {
  name: string; // Loan__c Name
  status: string;
  loanPurpose: string;
  loanAmount: number | null;
  propertyAddress: string;
  propertyCity: string;
  applicationTaken: boolean;
  isRefinance: boolean;
  isCashOut: boolean;
}

export interface CurrentMortgage {
  subjectPropertyStreet: string;
  subjectPropertyCity: string;
  currentMortgageBalance: number | null;
  currentInterestRate: number | null;
  currentLoanType: string;
  currentLenderName: string; // partially filled in production — highlight when empty
}

export const borrower: BorrowerContact = {
  firstName: "Marcus",
  lastName: "Delgado",
  phone: "(415) 555-0182",
  mobilePhone: "(415) 555-0182",
  email: "marcus.delgado@gmail.com",
  birthdate: "1984-06-12",
  leadSource: "Refi Web Lead",
  mailingStreet: "2841 Larkspur Lane",
  mailingCity: "Oakland",
  mailingState: "CA",
  mailingZip: "94610",
  hasCoBorrower: false,
};

export const latestLoan: LatestLoan = {
  name: "LN-100482",
  status: "Application Started",
  loanPurpose: "Refinance",
  loanAmount: null, // requested loan amount not yet entered
  propertyAddress: "2841 Larkspur Lane",
  propertyCity: "Oakland",
  applicationTaken: true,
  isRefinance: true,
  isCashOut: true,
};

export const currentMortgage: CurrentMortgage = {
  subjectPropertyStreet: "2841 Larkspur Lane",
  subjectPropertyCity: "Oakland",
  currentMortgageBalance: 412000,
  currentInterestRate: 6.875,
  currentLoanType: "30-Year Fixed Conventional",
  currentLenderName: "", // missing — must be highlighted
};

export interface ChecklistItem {
  id: string;
  label: string;
  status: ChecklistStatus;
}

export const completionChecklist: ChecklistItem[] = [
  { id: "phone", label: "Confirm phone number", status: "complete" },
  { id: "email", label: "Add email if missing", status: "complete" },
  { id: "birthdate", label: "Confirm birthdate", status: "complete" },
  { id: "mailing", label: "Complete mailing address", status: "complete" },
  { id: "balance", label: "Confirm current mortgage balance", status: "complete" },
  { id: "rate", label: "Confirm current interest rate", status: "complete" },
  { id: "lender", label: "Add current lender", status: "incomplete" },
  { id: "amount", label: "Add requested loan amount on latest loan", status: "incomplete" },
];

export function formatCurrency(value: number | null): string {
  if (value === null) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(iso: string): string {
  if (!iso) return "";
  return new Date(iso + "T00:00:00").toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
